/* eslint-disable import/extensions */

import { decodeColor } from './shared-configs/utils.js';

export const createColorPaletteTitleWidget = (keyForPaletteTitle) => {
	return {
		tagName: 'Text',
		key: keyForPaletteTitle,
		text: ''
	};
};

export const createColorPaletteWidget = (keyForPalette) => {
	return {
		tagName: 'ColorPalette',
		key: keyForPalette,
		useGradient: false
	};
};

export const getCustomPalette = (value, host) => {
	const { themePaletteId, themePaletteColors } = getThemePaletteInfo();
	const prevThemePaletteId = host.getProperty('prevThemePaletteId');
	const parsedThemePaletteColors = themePaletteColors.map((color) => ({
		color,
		changed: false
	}));
	if (!value) return parsedThemePaletteColors;

	const parsedValue = JSON.parse(value);

	if (prevThemePaletteId === themePaletteId) return parsedValue;

	return [
		...parsedThemePaletteColors,
		...parsedValue.filter((colorInfo) => colorInfo.changed === true)
	];
};

export const hasThemePaletteBeenMutated = (customPalette) => {
	const parsedCustomPalette = customPalette && JSON.parse(customPalette);
	if (parsedCustomPalette?.length !== 0)
		return parsedCustomPalette.find((colorInfo) => colorInfo.changed);
	return false;
};

export const getThemePaletteName = () => {
	const themePaletteInfo = window.mstrApp.rootCtrl?.docCtrl.model.plt;
	const dossierPaletteThemes = window.mstrConfig.paletteThemes.palettes;
	return dossierPaletteThemes.find((palette) => palette.pltid === themePaletteInfo.did)?.n;
};

const getThemePaletteInfo = () => {
	const themePaletteInfo = window.mstrApp.rootCtrl?.docCtrl.model.plt;
	const themePaletteColors = themePaletteInfo.colors.map((encodedColor) =>
		decodeColor(encodedColor)
	);
	const themePaletteId = themePaletteInfo.did;
	return {
		themePaletteId,
		themePaletteColors
	};
};
